import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthFetch } from './api/authFetch';
import { gemerkteDarstellung, wendeDarstellungAn } from './utils/darstellung';

// Anmeldung an ALLE Backend-Aufrufe hängen — muss vor dem ersten Request
// stehen, also ganz früh (siehe api/authFetch.js).
installAuthFetch();

// Darstellung (Theme + Schriftgröße) hängt seit Welle 99 am Konto. Hier wird
// nur der zuletzt gemerkte Wert gesetzt — sofort vor dem ersten Render, damit
// auch Navbar-lose Ansichten (Tools-Portal, /zeit, eingeschränkte Tool-User)
// richtig aussehen und nichts aufblitzt. Den echten Wert holt App.js vom
// Server, sobald die Anmeldung steht. Vorgabe bleibt dunkel.
wendeDarstellungAn(gemerkteDarstellung());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
